class Field {
	constructor(field, rowData, metadata, setReload) {
		if (new.target === Field) {
			throw new Error('Cannot instantiate abstract class');
		}
		this.id = field.id;
		this.name = field.name;
		this.type = field.type;
		this.uiValueProp = field.uiValueProp;
		this.setZoneField(field, rowData, metadata, setReload);
	}

	setZoneField(field, rowData, metadata, setReload) {
		if (
			field.id !== 'zoneId' &&
			field.id !== 'contractZoneId' &&
			field.id !== 'orderZoneId'
		)
			return;

		this.canUpdateAddress =
			!!field.onChange ||
			rowData?.eventProps?.changeAddress ||
			metadata?.eventProps?.changeAddress;
		this.setReload = setReload;
	}
}

export class StandardField extends Field {
	constructor({ field, rowData, metadata, setReload }) {
		super(field, rowData, metadata, setReload);
		this.uiValuePropLevel = field.uiValuePropLevel;
		this.dateFormat = field.dateFormat;
		this.filterable = field.filterable;
		this.unselectable = field.unselectable;
		this.width = field.width;
		this.show = field.show;
		this.onChange = field.onChange;
		this.onClick = field.onClick;
		this.isClickable = field.isClickable;
		this.nameField = field.nameField;
		this.refreshRowData = field.refreshRowData;
		this.canManageLines = field.canManageLines;
		this.canManageOrders = field.canManageOrders;
		this.disableOverview = field.disableOverview;
		this.orderOverviewMode = field.orderOverviewMode;
		this.opensPaycutSummary = field.opensPaycutSummary;
		this.opensPaymentSummary = field.opensPaymentSummary;
		this.ordersControlPrimaryField = field.ordersControlPrimaryField;
		this.ordersControlSelectionEnabled = field.ordersControlSelectionEnabled;
		this.disableEdit = field.disableEdit;
		this.disableCreatePackage = field.disableCreatePackage;
		this.centerContent = field.centerContent;
		this.isTransferredQuantity = field.isTransferredQuantity;
		this.usesAmountAsCurrentValue = field.usesAmountAsCurrentValue;
		this.formatAsDecimal = field.formatAsDecimal;
		this.editMode = field.editMode;
		this.isEditable = field.isEditable;
		this.onSubmitEdit = field.onSubmitEdit;
		this.isSubmitting = field.isSubmitting;
		this.editResetKey = field.editResetKey;
		this.minValue = field.minValue;
		this.precision = field.precision;
		this.preserveExistingImportService = field.preserveExistingImportService;
		this.seriesStateEditor = field.seriesStateEditor;
		this.compactTransactionCard = field.compactTransactionCard;
	}
}

export class OverviewField extends Field {
	constructor({ field, rowData, metadata, setReload }) {
		super(field, rowData, metadata, setReload);
		this.value = field.value;
		this.uiValue = field.uiValue;
		this.main = field.main;
	}
}
